import React from 'react';
import styled from 'styled-components';

import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';
import { colors, fonts } from '@/constants/theme';

function Complectation() {
  const data = useTypedSelector(selectDetailedCarData);

  if (!data) {
    return null;
  }

  const {
    catalog: { complectation },
    params: {
      body,
      fuel,
      battery,
      batteryCapacity,
      distanceLimit,
      wheel,
      enginePower,
      maxSpeed,
      time0To100,
      chargeDcTime,
      seatsCount,
      year,
    },
  } = data;

  const complectationItems = [
    body?.label ? { name: 'Тип кузова', value: body.label } : null,
    fuel?.label ? { name: 'Тип двигателя', value: fuel?.label } : null,
    battery?.label ? { name: 'Батарея', value: battery.label } : null,
    batteryCapacity
      ? { name: 'Емкость батареи', value: batteryCapacity + ' кВт*ч' }
      : null,
    distanceLimit ? { name: 'Запас хода', value: distanceLimit + ' км' } : null,
    wheel?.label ? { name: 'Привод', value: wheel?.label } : null,
    enginePower
      ? { name: 'Мощность двигателя', value: enginePower + ' л.c' }
      : null,
    maxSpeed
      ? { name: 'Максимальная скорость', value: maxSpeed + ' км/ч' }
      : null,
    time0To100
      ? { name: 'Время разгона до 100 км/ч', value: time0To100 + ' сек' }
      : null,
    chargeDcTime
      ? {
          name: 'Время зарядки постоянным током (DC)',
          value: chargeDcTime + ' ч',
        }
      : null,
    seatsCount ? { name: 'Количество мест', value: String(seatsCount) } : null,
    year ? { name: 'Год выпуска', value: String(year) } : null,
  ];

  return (
    <Component>
      <Title>Комплектация {complectation}</Title>
      <ListsWrapper>
        <List>
          {complectationItems.map((listItem, index) =>
            listItem ? (
              <ListItem key={index}>
                <Item>{listItem.name}</Item>
                <Item>{listItem.value}</Item>
              </ListItem>
            ) : null
          )}
        </List>
      </ListsWrapper>
    </Component>
  );
}

export default Complectation;

const Component = styled.div`
  margin-top: 50px;
`;

const Title = styled.div`
  line-height: 16px;
  font-family: ${fonts.GrtskTera};
  font-size: 20px;
  text-align: left;
  font-weight: 600;
  color: ${colors.blue100};
`;

const ListsWrapper = styled.div`
  display: flex;
  margin-top: 20px;
  border-radius: 5px;
`;

const List = styled.ul`
  flex: 100%;
  max-width: 100%;
  border: 1.3px solid ${colors.gray500};
  border-radius: 5px;
`;

const ListItem = styled.li`
  font-family: ${fonts.GrtskTera};
  font-size: 13px;
  padding: 9px 15px;
  color: ${colors.black};
  white-space: nowrap;
  list-style-type: disc;
  display: flex;
  justify-content: space-between;
  width: 100%;
  border: 1px solid ${colors.gray1300};
  -webkit-print-color-adjust: exact !important;
  color-adjust: exact !important;

  &:first-child {
    border-radius: 5px 5px 0 0;
  }
  &:last-child {
    border-radius: 0 0 5px 5px;
  }

  &:nth-child(odd) {
    background-color: ${colors.gray1300};
  }
`;

const Item = styled.span``;
